export default "__VITE_ASSET__BB606jcn__"